import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { Paginator } from 'primeng/paginator';
import { AppSettings } from '../Constant/AppSettings';
import { ContentService } from '../services/content/content.service';
import { UtilsService } from '../services/utils/utils.service';

import ImageResize from 'quill-image-resize-module';
import Quill from 'quill';
import { PrivilegeService } from '../services/privilege/privilege.service';
Quill.register('modules/imageResize', ImageResize);

@Component({
  selector: 'app-frequently-asked-questions',
  templateUrl: './frequently-asked-questions.component.html',
  styleUrls: ['./frequently-asked-questions.component.css']
})
export class FrequentlyAskedQuestionsComponent implements OnInit {
  items: MenuItem[] = [{ label: 'Frequently Asked Questions' }];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };
  @ViewChild('p', { static: false }) paginator?: Paginator;
  menuItems: MenuItem[] = [];
  faqId = '';
  cols: any[] = [];
  faqsList: any[] = [];
  disabled: boolean = false;
  isLoading: boolean = false;
  innerWidth: any;
  modules: any = {};
  //Paginator variable
  timer: any;
  pageSize: any = 0;
  currentPage: any = 1;
  totalCount: any = 0;
  searchInputText: string = '';
  //Dialog
  questionText: string = '';
  answerText: any = '';
  categoryText: string = '';
  headerName: string = '';
  displayAddEditModal: boolean = false
  displayViewModal: boolean = false

  categories: any;
  filteredFaqs: any;
  selectedCategory = 'All';

  searchKeyword: string = '';

  constructor(
    public utils: UtilsService,
    private messageService: MessageService,
    private privilegeService: PrivilegeService,
    private confirmationService: ConfirmationService,
    private contentService: ContentService
  ) { }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.cols = [
      { field: 'question', header: 'Question' },
    ]
    this.modules = {
      imageResize: {},
    }
    this.getAllFaq();
  }

  onCategoryChange(category: string) {
    this.selectedCategory = category;
    this.searchKeyword = '';
    this.filteredFaqs = category === 'All' ? [...this.faqsList] : this.faqsList.filter(faq => faq.category === category);
  }

  performSearch(keyword: string) {
    if(keyword == null){
      this.getAllFaq();
    }else {
    this.searchKeyword = keyword;
    this.selectedCategory = 'All';
    const lowerKeyword = keyword.toLowerCase();
    this.filteredFaqs = this.faqsList.filter(
      faq => faq.question.toLowerCase().includes(lowerKeyword) || faq.answer.toLowerCase().includes(lowerKeyword)
    );}
  }

  onSearchKeydown(event: KeyboardEvent, value: string): void {
    if(value.length === 1){
      this.getAllFaq();
    }
    if (event.key) {
      this.performSearch(value);
    }
  }

  addFaq() {
    this.showProgressBar()
    if (this.questionText == '') {
      this.showErrorMessage('Question field is empty.')
      this.hideProgressBar();
      return;
    }
    if (this.answerText == '') {
      this.showErrorMessage('Answer field is empty.')
      this.hideProgressBar();
      return;
    }
    if (this.categoryText == '') {
      this.showErrorMessage('Category field is empty.')
      this.hideProgressBar();
      return;
    }
    const Data = {
      data: {
        question: this.questionText,
        answer: this.answerText,
        category: this.categoryText,
        contentType: "FAQ"
      }
    };
    console.log("add data:", JSON.stringify(Data));
    this.contentService.addContent(Data).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Add Faq Post Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.showSuccessMessage(json.response.status, json.response.displayMessage)
          this.showHideModalDialog('add_faq')
          this.getAllFaq();
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
        this.hideProgressBar()
      },
      (error) => {
        console.log(error);
        this.showErrorMessage(AppSettings.ERROR_MSG)
        this.hideProgressBar()
      }
    );
  }

  editFaq() {
    this.showProgressBar()
    if (this.questionText == '') {
      this.showErrorMessage('Question field is empty.')
      this.hideProgressBar();
      return;
    }
    if (this.answerText == '') {
      this.showErrorMessage('Answer field is empty.')
      this.hideProgressBar();
      return;
    }
    if (this.categoryText == '') {
      this.showErrorMessage('Category field is empty.')
      this.hideProgressBar();
      return;
    }
    const Data = {
      data: {
        question: this.questionText,
        answer: this.answerText,
        category: this.categoryText,
        contentType: "FAQ"
      }
    };
    console.log("add data:", JSON.stringify(Data));
    this.contentService.editContent(Data, this.faqId).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Edit Faq Post Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.showSuccessMessage(json.response.status, json.response.displayMessage)
          this.showHideModalDialog('edit_faq')
          this.selectedCategory = 'All';
          this.getAllFaq();
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
        this.hideProgressBar()
      },
      (error) => {
        console.log(error);
        this.showErrorMessage(AppSettings.ERROR_MSG)
        this.hideProgressBar()
      }
    );
  }

  deleteFaq(item: any) {
    // console.log('id:' + item + ', event:' + JSON.stringify(e))
    this.showProgressBar()
    this.contentService.deleteContent(item.id).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Delete Faq Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.showSuccessMessage(json.response.status, json.response.displayMessage)
          this.selectedCategory = 'All';
          this.getAllFaq();
        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }
        this.hideProgressBar()
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar()
      }
    );
  }


  getFaq(type: any, item: any) {
    switch (type) {
      case 'edit_faq':
        this.showHideModalDialog('edit_faq')
        break;
      case 'view_faq':
        this.showHideModalDialog('view_faq')
        break;
    }

    this.faqId = item.id;
    this.showProgressBar()
    this.contentService.getContent(item.id).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Get Faq Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.questionText = json.data.question
          this.answerText = json.data.answer
          this.categoryText = json.data.category
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
        this.hideProgressBar()
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar()
      }
    );
  }

  getAllFaq() {
    this.showProgressBar()
    this.faqsList = []
    this.contentService.getAllContent("FAQ").subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('List All Faqs Response --->> ' + JSON.stringify(json));

        if (json.response.status == 'SUCCESS') {
          this.faqsList = json.data;
        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }

        const categoryStrings = ['All', ...new Set(this.faqsList.map(faq => faq.category))]; // Extract unique categories
        this.filteredFaqs = [...this.faqsList];

        this.categories = categoryStrings.map(category => ({
          label: category,
          value: category
        }));
        this.hideProgressBar()
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar()
      }
    );
  }

  confirmDeleteDialog(item: any) {
    this.messageService.clear();
    this.confirmationService.confirm({
      message: 'Do you want to delete this FAQ ?',
      header: 'Delete Confirmation',
      icon: 'pi pi-trash',
      accept: () => {
        this.deleteFaq(item);
      },
    });
  }


  showHideModalDialog(type: string) {
    switch (type) {
      case 'edit_faq':
        this.headerName = 'Edit FAQ';
        this.displayAddEditModal = !this.displayAddEditModal;
        break;
      case 'add_faq':
        this.clearFormData();
        this.headerName = 'Add FAQ';
        this.displayAddEditModal = !this.displayAddEditModal;
        break;
      case 'view_faq':
        this.clearFormData();
        this.headerName = 'View FAQ';
        this.displayViewModal = !this.displayViewModal;
        break;
    }
  }

  getMenuItemsForItem(item: any): MenuItem[] {
    const context = item;
    return [
      {
        label: 'Options',
        items: [{
          label: 'Edit',
          icon: 'pi pi-pencil',
          command: e => this.getFaq('edit_faq', context)
        },
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: e => this.confirmDeleteDialog(context)
        },
        {
          label: 'View',
          icon: 'pi pi-eye',
          command: e => this.getFaq('view_faq', context)
        }
        ]
      },
    ]
  }

  clearFormData() {
    this.messageService.clear('errMsg');
    this.questionText = ''
    this.answerText = ''
    this.categoryText = ''
  }

  resetFaqsList() {
    this.searchKeyword = '';
    this.selectedCategory = 'All';
    this.getAllFaq();
  }

  showErrorMessage(msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: 'error',
      detail: msg,
    });
  }

  showErrorToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'error',
      detail: msg,
    });
  }

  showSuccessMessage(status: string, msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'success',
      summary: status,
      detail: msg,
    });
  }

  hideProgressBar() {
    this.isLoading = false;
    this.disabled = false;
  }

  showProgressBar() {
    this.messageService.clear('errMsg');
    this.isLoading = true;
    this.disabled = true;
  }

  showDialogMaximized(event: any, dialog: Dialog) {
    if (this.innerWidth <= 640) {
      dialog.maximized = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  getPrivilege(id: any) {
    return this.privilegeService.getPrivileges(id);
  }

  get state(): string {
    return this.utils.state;
  }
}
